import Exception from "src/utils/exception";
import Constants from "src/utils/constants";
import DBOperationsComb from "src/utils/dbOperationsComb";

async function getMasterShops(config, offlineFirst = false) {
  try {
    return await DBOperationsComb.fetchData(
      {
        tableName: Constants.enums.TABLES_NAME_ENUM.MASTER_SHOPS_TABLE,
        fetchAll: true,
        ...config
      },
      offlineFirst
    );
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

async function getMasterRegions(config, offlineFirst = false) {
  try {
    return await DBOperationsComb.fetchData(
      {
        tableName: Constants.enums.TABLES_NAME_ENUM.MASTER_REGIONS_TABLE,
        fetchAll: true,
        ...config
      },
      offlineFirst
    );
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

async function getMasterCompanies(config, offlineFirst = false) {
  try {
    return await DBOperationsComb.fetchData(
      {
        tableName: Constants.enums.TABLES_NAME_ENUM.MASTER_COMPANIES_TABLE,
        fetchAll: true,
        ...config
      },
      offlineFirst
    );
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

export default {
  getMasterShops,
  getMasterRegions,
  getMasterCompanies
};
